<script>
  import Home from './components/Organisms/Home.svelte';

  export let name = '';
</script>

<Home />
